import Header from "../../header/header";
import "./page.css"

export function PopularSciencepage() {
    return (
        <body>
  
        <div id="top">
          <Header />
          <section class="py-5 text-center ">
            <div class="py-lg-5">
              <div class="col-lg-6 col-md-8 mx-auto">
                <h1 class="title display-1" >科普活動</h1>
              </div>
            </div>
          </section>
        </div>
        <div class="d-md-flex flex-md-equal w-100  ps-md-3 justify-content-center ">
          <div class="bg-body-tertiary me-md-3 pt-3 px-3 pt-md-3 px-md-5 text-left overflow-hidden col-md-8">
            <div class="row featurette">
              <div >
                <p class="display-5 mt-md-5 " id="invent">科普活動</p>
                <p class="content mt-md-5 px-md-3">1. 111學年度，國立科學工藝博物館，2022第三屆臺灣科學節－科普市集，2022/11/04-06。</p>
                <p class="content mt-md-5 px-md-3">2.	111學年度，高雄市內門區木柵國小，雷射雕刻木鑰匙圈及編繩製作體驗，2022/11/23。</p>
                <p class="content mt-md-5 px-md-3">3.	111學年度，高雄市內門區木柵國小，雷射雕刻皮革鑰匙圈製作體驗，2022/11/30。</p>
                <p class="content mt-md-5 px-md-3">4.	111學年度，雷射雕刻皮革鑰匙圈製作體驗，高雄市內門區木柵教會婦女團契，112/01/12。</p>
                <p class="content mt-md-5 px-md-3">5.	111學年度，雷射雕刻皮革鑰匙圈製作體驗，高雄市內門區木柵教會青少年團契，112/03/04 。</p>
                <p class="content mt-md-5 px-md-3">6.	111學年度，雷雕科普知識及雷雕體驗，高雄市六龜區六龜高中，112/03/18。</p>
                <p class="content mt-md-5 px-md-3">7.	111學年度，雷雕科普知識及雷雕體驗，高雄市內門區內門國中，112/04-05月份。</p>
                <p class="content mt-md-5 px-md-3">8.	110學年度，國立高雄市六龜高中，機器人程式設計冬令營 ，2020/07/21-24。</p>
                <p class="content mt-md-5 px-md-3">9.	110學年度，國立正修科技大學，Maker創客X AI機器人 ，2020/07/21-24。</p>
                <p class="content mt-md-5 px-md-3">10.	109學年度，長庚科技大學，人工智慧物聯網作品與資訊教育服務經驗分享，專題演講，2019/10/29。</p>
                <p class="content mt-md-5 px-md-3">11.	109學年度，台中科技大學，人工智慧物聯網作品與資訊教育服務經驗分享，專題演講，2020/03/27。</p>
                <p class="content mt-md-5 px-md-3">12.	109學年度，正修科技大學資訊管理系，人工智慧物聯網作品與資訊教育服務經驗分享，專題演講，2020/10/24。</p>
                <p class="content mt-md-5 px-md-3">13.	109學年度，國立高雄大學資訊工程系，人工智慧物聯網作品與資訊教育服務經驗分享，專題演講，2020/10/08。</p>
                <p class="content mt-md-5 px-md-3">14.	108學年度，國立科學工藝博物館夏令營，小小設計師系列「Scratch異想世界」 ，2019/7-8。</p>
                <p class="content mt-md-5 px-md-3">15.	108學年度，國立科學工藝博物館夏令營，小小設計師系列「蟒哥與小bit程式創作營」，2019/7-8。</p>
                <p class="content mt-md-5 px-md-3">16.	108學年度，國立東華大學，小小程式師幻想世界冬令營 ，2020/01/21-24。</p>
                <p class="content mt-md-5 px-md-3">17.	108學年度，國立正修科技大學，小小程式師幻想世界冬令營 ，2020/07/21-24。</p>
                <p class="content mt-md-5 px-md-3">18.	107學年度，國立科學工藝博物館夏令營，小小設計師系列「Scratch異想世界」，2018/7-8。</p>
                <p class="content mt-md-5 px-md-3">19.	107學年度，國立科學工藝博物館冬令營，小小設計師系列「Scratch異想世界」，2019/1-2。</p>
                <p class="content mt-md-5 px-md-3">20.	106學年度，瑞豐國小自然科目，空氣汙染環境教育推廣活動，2017/5-9。</p>
                <p class="content mt-md-5 px-md-3">21.	106學年度，瑞豐國小資訊科目，機器人程式設計活動，2017/11-12。</p>
                <p class="content mt-md-5 px-md-3">22.	106學年度，瑞豐國小資訊科目，Scratch程式設計活動，2018/3-5。</p>
                <p class="content mt-md-5 px-md-3">23.	105學年度，瑞豐國小綜合科目，機器人體驗服務學習活動，2017/4。</p>
                <p class="content mt-md-5 px-md-3">24.	104年度教育部資訊志工團隊計畫，團隊名稱：嘉藥資管一級棒，服務對象：高雄市-六龜DOC及市立寶來國中 (104087)，教育部，計畫主持人，2015.07.15 ~ 2016.05.31。</p>
                <p class="content mt-md-5 px-md-3">25.	104年「鼓勵大專校院帶動高中職、國中小學辦理服務學習攜手計畫 」，教育部青年發展署補助「帶動高中職以下學校辦理服務學習攜手計畫」，創意數位資訊應用與行動學習，2015/03/01~2015/09/30。</p>
                <p class="content mt-md-5 px-md-3">26.	104學年度，海埔國小數學科目，行動學習服務學習活動，2015/5-6。</p>
                <p class="content mt-md-5 px-md-3">27.	103學年度，海埔國小資訊科目，電子書服務學習活動，2014/10。</p>
                
  
              </div>
  
            </div>
            <div class="text-center" id="MyBlog">
        <a  href="#top">回頂部</a>
      </div>
          </div>
          
        </div>
        
          
      
        <div class="aa"></div>
      </body>
  
    );
  }